import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../images/back.svg";
import { IMAGE_BASE_URL } from "../../../helpers/constants";
import { Button, Modal, Popconfirm, Popover } from "antd";
import { useContext, useEffect, useState } from "react";
import axios from "../../../axios/axios";
import { toast } from "react-toastify";
import PdfViewer from "../../../components/PDFViewer/PDFViewer";
import { handleDownload } from "../../../common/Utilities";
import { FlooringPdfBaseUrl, FormatCurrency } from "../../../common/Constants";

const PreviewAAF = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const floorData = location.state.floorData?.FloorCaseDetails;
  const AppId = location.state?.AppId;
  const AgentId = location.state?.AgentId;
  const SelectedAgent = floorData?.cart[0];
  const dataObj = location.state.dataObj;
  const VehicleInfo = floorData?.vehicleInfo;
  const DealerInfo = SelectedAgent?.agent?.dealer_info;
  const IssueAAF = location.state.issueAAf
  const isVoucherRejected = location?.state?.isVoucherRejected;
  const preIssuedFloorAmount = dataObj?.preIssuedFloorAmount;
  const [flooringSettingsData, setFlooringSettingsData] = useState({});
  const [isissueAFF, setisissueAFF] = useState(false);
  const [AAfData, setAAfData] = useState(null);

  const handleselAFF = async (type) => {
    if (type === "undo") {
      const resp = await axios.post(
        `/flooring/application/approvalStatus/${AppId?.appId}`,
        {
          ...dataObj,
          agent_approved_status: 0,
          agent_voucher_approved_status: 0,
          preIssuedFloorAmount: preIssuedFloorAmount
        }
      );
      if (resp.status < 400) {
        toast.success(resp.data?.message);
        setisissueAFF(false);
        navigate("/flooring-cases", {
          state: {
            ...location.state
          },
        });
      }
    } else {
      const resp = await axios.post(
        `/flooring/application/approvalStatus/${AppId?.appId}`,
        {
          ...dataObj,
          preIssuedFloorAmount: preIssuedFloorAmount
        }
      );
      if (resp.status < 400) {
        toast.success(resp.data?.message);
        setisissueAFF(false);
        navigate("/flooring-cases", {
          state: {
            ...location.state,
          },
        });
      }
    }
  };

  const GetOwnerType = (item, val) => {
    const temp = flooringSettingsData[`${item}`]?.filter(
      (it) => it.value == val
    );
    if (temp?.length > 0) {
      return temp[0]?.label;
    } else {
      return "";
    }
  };

  const GetFlooringSettings = async () => {
    const resp = await axios.get("/flooring/settings");
    if (resp.status < 400) {
      setFlooringSettingsData(resp.data?.data);
    }
  };

  useEffect(() => {
    GetFlooringSettings();
  }, []);

  const GetAAFSetupData = async () => {
    const resp = await axios.get(`/approval/advice-flooring`);
    if (resp.status < 400) {
      setAAfData(resp.data?.data);
    }
  };
  useEffect(() => {
    GetAAFSetupData();
  }, []);


  let UndoInfoText = (
    <div className="w-[200px] pt-[10px] pb-[5px]">
      <p className="my-[7px] text-[12px]">
        You have already issued AAF, you can only UNDO it before the dealer signs and accepts the AAF.
      </p>
    </div>
  );

  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">
            <span
              className="cursor-pointer"
              onClick={() => {
                if (SelectedAgent?.agent?.agent_approved_status == 1) {
                  navigate("/flooring-cases/view");
                } else {
                  navigate("/flooring-cases/view/issueAAF", {
                    state: {
                      floorData: location.state.floorData,
                      dataObj: dataObj,
                    },
                  });
                }
              }}
            >
              <BackIcon />
            </span>
            Flooring Cases
          </h1>
        </div>
      </header>
      {IssueAAF ? (
        <section className="approval-advice-section">
          <div className="approval-advice-header">
            <div className="approval-advice-logo">
              <img
                src={`${IMAGE_BASE_URL}/${SelectedAgent?.agent?.icon}`}
                alt=""
              />
            </div>
            <div>
              <h2>Approval Advice For Flooring</h2>
              <h3>SN:{floorData?.vehicleInfo?.application_uniqueId}</h3>
            </div>
          </div>
          <div className="approval-advice-body">
            <div className="preview-list-block">
              <h2 className="approval-heading">{SelectedAgent?.agent?.name}</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>UEN:</h3>
                  <p>{AAfData?.uen_no}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Contact No.:</h3>
                  <p>{SelectedAgent?.agent?.phoneNumber} </p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Address:</h3>
                  <p>
                    {SelectedAgent?.agent?.addressLine1},{" "}
                    {SelectedAgent?.agent?.addressLine2} -
                    {SelectedAgent?.agent?.postalCode}
                  </p>
                </div>
              </div>
            </div>
            <div className="preview-list-block">
              <h2 className="preview-subheading">Dealer Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Contact No.:</h3>
                  <p>{DealerInfo?.phoneNumber}</p>
                </div>
                <div className="preview-list">
                  <h3>NRIC / UEN No.:</h3>
                  <p>{DealerInfo?.uenNumber}</p>
                </div>{" "}
                <div className="preview-list">
                  <h3>Date:</h3>
                  <p>{DealerInfo?.approvedAt}</p>
                </div>
                <div className="preview-list">
                  <h3>Address:</h3>
                  <p>
                    {DealerInfo?.addressLine1}, {DealerInfo?.addressLine2} -
                    {DealerInfo?.postalCode}{" "}
                  </p>
                </div>{" "}
                <div className="preview-list">
                  <h3>Email Address:</h3>
                  <p>{DealerInfo?.email}</p>
                </div>
              </div>
            </div>
            <div className="preview-list-block">
              <h2 className="preview-subheading">Seller Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Name</h3>
                  <p>{VehicleInfo?.seller_name}</p>
                </div>
              </div>
            </div>
            <div className="preview-list-block">
              <h2 className="preview-subheading">Vehicle Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Vehicle No.:</h3>
                  <p>{VehicleInfo?.vehicle_reg_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Make & Model:</h3>
                  <p>{VehicleInfo?.make_model}</p>
                </div>{" "}
                <div className="preview-list">
                  <h3>Access Code:</h3>
                  <p>{VehicleInfo?.access_code}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>First Reg Date:</h3>
                  <p>{VehicleInfo?.first_reg_date}</p>
                </div>
                <div className="preview-list">
                  <h3>Y.O.M:</h3>
                  <p>{VehicleInfo?.yom}</p>
                </div>
                <div className="preview-list">
                  <h3>OMV:</h3>
                  <p>${FormatCurrency(VehicleInfo?.OMV)}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Engine No.:</h3>
                  <p>{VehicleInfo?.engine_no}</p>
                </div>
                <div className="preview-list">
                  <h3>Chassis No.:</h3>
                  <p>{VehicleInfo?.chassis_no}</p>
                </div>{" "}
                <div className="preview-list">
                  <h3>COE Expiry:</h3>
                  <p>{VehicleInfo?.COE_expiry}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>COE-QP / PQP Paid:</h3>
                  <p>${FormatCurrency(VehicleInfo?.COE_value)}</p>
                </div>
                <div className="preview-list">
                  <h3>ARF Paid:</h3>
                  <p>${VehicleInfo?.min_parf.slice(
                    0,
                    VehicleInfo.min_parf.indexOf(".")
                  )}</p>
                </div>
                <div className="preview-list">
                  <h3>COE Rebate:</h3>
                  <p>${FormatCurrency(VehicleInfo?.coe_rebate)}</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>PARF Rebate:</h3>
                  <p>${FormatCurrency(VehicleInfo?.parf_rebate)}</p>
                </div>
                <div className="preview-list">
                  <h3>Total Rebate:</h3>
                  <p>${FormatCurrency(VehicleInfo?.total_rebate)}</p>
                </div>
              </div>

            </div>
            <div className="preview-list-block">
              <h2 className="preview-subheading">Floor Details</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Floor Amount:</h3>
                  <p>${dataObj?.intended_floor_amount}</p>
                </div>
                <div className="preview-list">
                  <h3>Purchase Price:</h3>
                  <p>${Math.round(VehicleInfo?.purchase_price)}</p>
                </div>
                <div className="preview-list">
                  <h3>Flooring Percentage:</h3>
                  <p>{((dataObj?.intended_floor_amount / VehicleInfo?.purchase_price) * 100).toFixed(2)}%</p>
                </div>
              </div>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>Int Rate Per 30 Days:</h3>
                  <p>{dataObj?.agent_interest_rate}%</p>
                </div>
                <div className="preview-list">
                  <h3>Admin Fee:</h3>
                  <p>${dataObj?.agent_admin_fee}</p>
                </div>{" "}
                <div className="preview-list">
                  <h3>Interest Payment Due Date:</h3>
                  <p>{SelectedAgent?.agent?.disbursement?.flooring_start_date}</p>
                </div>
              </div>
            </div>
            {!isVoucherRejected && (
              <div className="preview-list-block">
                <h2 className="preview-subheading">Voucher Conditions</h2>
                <div className="preview-list-group">
                  <div className="preview-list">
                    <h3>Is Voucher Applied ? : {`YES`}</h3>
                  </div>
                </div>
              </div>
            )}
            {<div className="preview-list-block">
              <h2 className="preview-subheading">Other Conditions</h2>
              <div className="preview-list-group">
                <div className="preview-list">
                  <h3>{dataObj?.agent_other_conditions ? dataObj?.agent_other_conditions : '-'}</h3>
                </div>
              </div>
            </div>}
          </div>
        </section>
      ) : (
        <section>
          <PdfViewer
            AppId={AppId?.appId}
            AgentId={AgentId}
            title="AAF Document"
            type="AAF"
          />
        </section>
      )}


      <section className="approval-advice-footer">
        {!IssueAAF && (

          <Button
            onClick={() => {
              handleDownload(
                `${FlooringPdfBaseUrl}${AppId?.appId}/${AgentId}`
              );
            }}
            type="submit" className="sav_btn"
          >
            Download
          </Button>
        )}



        <Button
          className="sav_btn"
          onClick={() => {
            setisissueAFF(true);
          }}
          disabled={SelectedAgent?.agent?.dealer_approved_status == 1}
        >
          {SelectedAgent?.agent?.agent_approved_status == 1
            ? "Undo  AAF"
            : "Issue AAF"}
        </Button>

        {SelectedAgent?.agent?.agent_approved_status == 1 && (
          <Popover content={UndoInfoText} placement="bottom">
            <img
              src="/images/fi_info.svg"
              alt="info"
              className="inline-block ml-[8px] cursor-pointer"
            />
          </Popover>
        )}

      </section>
      <Modal
        open={isissueAFF}
        onCancel={() => setisissueAFF(false)}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">
            {SelectedAgent?.agent?.agent_approved_status == 1
              ? "Undo Issuded AAF Application?"
              : "Issue AAF Application?"}
          </h2>
          {SelectedAgent?.agent?.agent_approved_status == 1 && (
            <h6>
              You have already issued AAF, you can only UNDO it before the dealer signs and accepts the AAF. Are you sure?
            </h6>
          )}
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                setisissueAFF(false);
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              className="sav_btn"
              onClick={() => {
                handleselAFF(
                  SelectedAgent?.agent?.agent_approved_status == 1
                    ? "undo"
                    : "issue"
                );
              }}
            >
              {SelectedAgent?.agent?.agent_approved_status == 1 ? "UNDO" : "Confirm"}
            </Button>
          </div>
        </div>
      </Modal>
    </section >
  );
};

export default PreviewAAF;
